import { Component } from '@angular/core';
import '/picogramwebsite/public/css/style.css';
//  import {HeaderComponent} from './header/header.component';
// import {FooterComponent} from './Theme/components/footer/footer.component';
// import {LoginComponent} from './AuthModule/login.component';
// import {HomeComponent} from './Home/home.component';
// import {PersonComponent} from './Home/person/person.component';
import { ROUTER_DIRECTIVES } from '@angular/router';
import { Configuration } from './app.constants';

@Component({
  selector: 'my-app',
  directives: [ROUTER_DIRECTIVES],
  providers:[Configuration],
  template: require('./app.component.html'),
  // template : `  
         
  //           <a class="mdl-navigation__link" [routerLink]="['/login']">Login</a>            
  //           <a class="mdl-navigation__link" [routerLink]="['/home']">Home</a>
          
  //   <!-- Router Outlet -->
    
  //   <router-outlet></router-outlet>      
  //   <footer><footer>`,
  // styles: [require('./app.component.css')]
})
export class AppComponent { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.component.ts
 **/